export enum ApiUrlParams {
  ProjectId = 'projectId',
  ConfigurationId = 'configurationId',
  VersionId = 'versionId',
  TrackId = 'trackId',
  CommentId = 'commentId',
}
